// Regel „darf diese Übergabe noch abgebrochen (storniert) werden?".
//
// Kritischer Review-Fund K2: `abbrechenErfassung` (UebergabeListe.tsx) schrieb
// status='abgebrochen' OHNE Serverprüfung — anders als `jetztSenden` und der Routen-Guard,
// die beide über holeServerStatus() gehen. Der Einfrier-Trigger lässt den Übergang
// abgeschlossen→abgebrochen als Storno ausdrücklich zu (s. Migration
// 2026-07-26-uebergabe-einfrieren.sql), die Liste lädt sich aber nicht von selbst nach:
// Ein Büro-Tab, der offen steht, während vor Ort abgeschlossen wird, zeigt die Zeile
// beliebig lange als „In Erfassung — anderes Gerät". Ein Klick auf „Abbrechen" stornierte
// damit ein fertiges, unterschriebenes und bereits verschicktes Protokoll — unumkehrbar
// (zurück blockiert der Trigger), das PDF verschwindet aus der Oberfläche, und nicht
// einmal ein Grund stand dabei.
//
// Deshalb liegt die Entscheidung hier als reine Funktion (ohne Netz/DOM testbar) und
// wird in der Liste an ZWEI Stellen benutzt: vor der Rückfrage (aktueller Serverstatus)
// und noch einmal, wenn das bedingte Update `.eq('status','in_erfassung')` keine Zeile
// mehr trifft (Rennen zwischen Prüfung und Schreiben).
import type { ProtokollStatus } from './typen';

export type StornoEntscheidung =
  | { erlaubt: true }
  | { erlaubt: false; meldung: string };

/**
 * Storniert werden darf ausschließlich, was serverseitig NOCH `in_erfassung` ist.
 *
 * Bewusst NICHT „fail open" wie die übrigen Serverprüfungen dieses Moduls (Routen-Guard,
 * „Jetzt senden"): Die lassen im Zweifel das WEITERARBEITEN zu — hier ginge es dagegen um
 * eine unwiderrufliche Stornierung. Lässt sich der Stand nicht feststellen (kein Netz,
 * Zeile nicht mehr da), wird deshalb nicht storniert, sondern ehrlich gemeldet; der
 * Abbruch selbst braucht ohnehin eine Verbindung und würde sonst gleich danach scheitern.
 */
export function pruefeStornoErlaubt(serverStatus: ProtokollStatus | null): StornoEntscheidung {
  if (serverStatus === 'in_erfassung') return { erlaubt: true };
  if (serverStatus === 'abgeschlossen') {
    return {
      erlaubt: false,
      meldung: 'Dieses Protokoll wurde inzwischen abgeschlossen und kann nicht mehr abgebrochen werden.',
    };
  }
  if (serverStatus === 'abgebrochen') {
    return { erlaubt: false, meldung: 'Dieses Protokoll wurde bereits abgebrochen.' };
  }
  return {
    erlaubt: false,
    meldung: 'Der aktuelle Stand dieser Übergabe konnte nicht geprüft werden (keine Verbindung?). '
      + 'Es wurde nichts abgebrochen — bitte später erneut versuchen.',
  };
}
